<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.house_pad_series, 'Serie PAD')"
      v-model="padSeries"
      :rules="padSeriesValidationRules"
      name="pad_series"
      @input="onInput"
      variant="outlined"
      bg-color="surface"
      :tile="true"
      counter="2"
  >
  </v-text-field>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, watch, toRefs} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
  },
  setup(props, {emit}) {
    const {modelValue} = toRefs(props);
    const padSeries = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);


    watch(modelValue, (newValue) => {
      padSeries.value = newValue;
    });

    watch(padSeries, (newValue) => {
      const isValid = validatePadSeries(newValue);
      emit('update:modelValue', newValue);
      emit('validation-house-status', {field: `pad_series`, isValid});

    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const padSeriesValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => (v && v.length === 2) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
      (v: string) => /^[A-Za-z\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validatePadSeries(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = padSeriesValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return padSeriesValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validatePadSeries(padSeries.value);
      emit('validation-house-status', {field: `pad_series`, isValid});

      window.addEventListener('validate-house', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === `pad_series`) {
        const isValid = validatePadSeries(padSeries.value, true);
        if (isValid) {
          emit('validation-house-status', {field: data.detail, isValid});
        }
      }
    };

    return {
      padSeries,
      padSeriesValidationRules,
      translationList,
      translation,
      onInput(event) {
        padSeries.value = event.target.value ? event.target.value.toUpperCase() : null;
      },
      error
    };
  },
});
</script>
